// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1UlI4","title":"InfoRow_title__1J1J0"};